import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { usePostHog } from 'posthog-js/react';

//internal import
import { notifyError, notifySuccess } from "@utils/toast";
import ReviewServices from "@services/ReviewServices";
import { SidebarContext } from "@context/SidebarContext";
import * as gtag from "src/lib/gtag"

const useReviewSubmit = (product) => {
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [imageUrl, setImageUrl] = useState([]);
  const { toggleUpdater } = useContext(SidebarContext);
  const posthog = usePostHog();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const submitHandler = ({ text }) => {
    if (rating <= 0) {
      notifyError("please give a rating");
    } else if (imageUrl.length <= 0) {
      notifyError("Image is required!!");
    } else {
      setLoading(true);

      const data = {
        text,
        rating,
        attachment: imageUrl,
        product,
      };
      ReviewServices.addReview(data)
        .then((res) => {
          if (res) {
            setLoading(false); setValue("text", null);
            setRating(0);
            setImageUrl([]);
            toggleUpdater();
            notifySuccess("Review added successfully");
            gtag.event({
              action: "Review",
              params: {
                Item: product,
                Content: text,
                Rate: rating
              }
            });

            // PostHog event
            posthog?.capture('Product Reviewed', {
              product_id: product._id,
              name: product.title,
              rating: rating,
              review_body: text,
              has_images: imageUrl.length > 0,
              image_count: imageUrl.length
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          if (err.response.status !== 401) {
            notifyError(err.message);
          }
        });
    }
  };

  const setvalEdit = (e) => {
    const { value } = e.target;

    setRating(value);
  };

  return {
    handleSubmit,
    submitHandler,
    register,
    errors,
    loading,
    setvalEdit,
    rating,
    imageUrl,
    setImageUrl,
  };
};

export default useReviewSubmit;
